export const COMPANY_CLIENT_TABS = [
  { id: "clients", label: "Direct Clients", icon: "🧾" },
  { id: "shops", label: "Shops & Shop Clients", icon: "🏪" },
  { id: "orders", label: "Customer Orders", icon: "📦" },
  { id: "requests", label: "Pending Requests", icon: "📩" },
  { id: "payments", label: "Payments", icon: "💰" },
  { id: "milkSold", label: "Milk Sold", icon: "🥛" },
  { id: "analytics", label: "Reports & Insights", icon: "📊" },
  { id: "invoices", label: "Invoices", icon: "📑" },
  { id: "messages", label: "Messages", icon: "💬" },
  { id: "approvals", label: "Approvals", icon: "✅" },
];
